import api from '../api';

/**
 * Invalidate a coupon for a user.
 *
 * @param {string} userId - The ID of the user.
 * @param {string} couponId - The ID of the coupon to be invalidated.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const invalidateCoupon = async (userId, couponId) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/invalidateCoupon`;

  try {
    const response = await api.post(endpoint, {
      user_id: userId,
      coupon_id: couponId,
    });
    return response.data;
  } catch (error) {
    console.error('Error invalidating coupon:', error);
    throw error;
  }
}

export default invalidateCoupon;
